<button
  class="checkin__radio__item checkin__radio__item--hover"
  (click)="clickHandler()">
  <div *ngIf="icon" class="icon">
    <img [src]="icon">
    <span [innerHTML]="label | translate"></span>
  </div>
  <span *ngIf="!icon"[innerHTML]="label | translate"></span>
  <i [ngClass]="{ 'selected' : selected }"></i>
</button>
